import * as metadataAPI from '@adobe/edex/frontend/api/metadata';
import { MetadataType } from '@adobe/edex/ui/shared/frontend/utils/types';
import { classifyProducts } from '@adobe/edex/ui/shared/utils/metadata';

const timing = [
  {
    id: '6a25cd2c-e3b8-11ea-823a-128594b927d7',
    name: 'Less than 1 hour',
    i18nLabel: 'i18n.less_than_1_hour',
  },
  {
    id: 'd639d5c1-a2aa-430a-a508-c64c58283a79',
    name: '1-2 hours',
    i18nLabel: 'i18n.1_2_hours',
  },
  {
    id: 'f87e19aa-c1f5-4084-b6af-1d7ba013a578',
    name: '3-5 hours',
    i18nLabel: 'i18n.3_5_hours',
  },
  {
    id: '0ad98e06-10e0-4749-aa93-44a7a0170345',
    name: '6-10 hours',
    i18nLabel: 'i18n.6_10_hours',
  },
  {
    id: '16d6e5f3-2a0e-4513-9060-d0e4434d8599',
    name: 'More than 10 hours',
    i18nLabel: 'i18n.more_than_10_hours',
  },
];

enum AcademicLevelID {
  allAges = '5f93600c-19c4-4799-a603-fe3913681237',
}

const processors = {
  [MetadataType.products]: (state, type, items) => {
    state.classifiedProducts = classifyProducts(items);
    state[type] = items;
  },
  [MetadataType.contentStandards]: (state, type, items) => {
    const result = { general: [], ISTENETS: [] };
    items.forEach((cs) => result[cs.type].push(cs));
    state[type] = result;
  },
  [MetadataType.subjects]: (state, type, items) => {
    const result = [];

    items.forEach((subject) => {
      result.push(subject);
      subject.children.forEach((child) => {
        result.push(child);
      });
    });

    state[type] = result;
  },
  [MetadataType.fileTypes]: (state, type, items) => {
    const result = { byID: {}, byLabel: {} };
    items.forEach((ft) => (result.byLabel[ft.i18nLabel.replace('i18n.fileType.', '')] = ft.id));
    items.forEach((ft) => (result.byID[ft.id] = ft.i18nLabel.replace('i18n.fileType.', '')));
    state[type] = result;
  },
  [MetadataType.academicLevels]: (state, type, items) => {
    state[type] = items.filter((item) => item.id !== AcademicLevelID.allAges);
  },
};

const getDefaultState = () => ({
  ...Object.values(MetadataType).reduce((acc, type) => ({ ...acc, [type]: null }), {}),
  classifiedProducts: null,
  timing,
});

const metadata = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    set(state, { items, type }) {
      // TODO: sort on BE
      if (items[0]?.sortOrder !== undefined) {
        items.sort((a, b) => a.sortOrder - b.sortOrder);
      }

      if (processors[type]) {
        processors[type](state, type, items);
      } else {
        state[type] = items;
      }
    },
  },
  actions: {
    async fetchByType({ state, commit }, type: MetadataType) {
      if (state[type]) {
        return;
      }
      const {
        data: { [type]: items },
      } = await metadataAPI.fetchMetadataByType(type);
      commit('set', { items, type });
    },
  },
};

export default metadata;
